import React from 'react';
const WhiteCloseIcon = (props) => {
    const { IconHeight, iconWidth } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: iconWidth ? iconWidth : "16", height: IconHeight ? IconHeight : "16", viewBox: "0 0 16 16", fill: "none" },
        React.createElement("path", { d: "M12.6667 4.27398L11.7267 3.33398L8.00004 7.06065L4.27337 3.33398L3.33337 4.27398L7.06004 8.00065L3.33337 11.7273L4.27337 12.6673L8.00004 8.94065L11.7267 12.6673L12.6667 11.7273L8.94004 8.00065L12.6667 4.27398Z", fill: "currentColor" })));
};
export default WhiteCloseIcon;
